const ShippingInstructions = (props) => {
  const { order } = props;
  if (!order.shippingInstructions || order.shippingInstructions === '') {
    return null;
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>Shipping Instructions</h4>
      <p>{order.shippingInstructions}</p>
    </div>
  );
};

export default ShippingInstructions;
